import React from 'react';
import styles from "./index.module.scss";
import "./index.scss";
import classNames from "classnames";
import { Col, Row } from "antd";

import { ReactComponent as LeftArrow } from './images/left-arrow.svg';
import { ReactComponent as RightArrow } from './images/right-arrow.svg';
import { ReactComponent as QuoteStart } from './images/round-quotes-start.svg';
import { ReactComponent as QuoteEnd } from './images/round-quotes-end.svg';
import Image1 from './images/image-1.png';
import Image12x from './images/image-1@2x.png';
import Image13x from './images/image-1@3x.png';

import Image2 from './images/image-2.png';
import Image22x from './images/image-2@2x.png';
import Image23x from './images/image-2@3x.png';

import Image3 from './images/image-3.png';
import Image32x from './images/image-3@2x.png';
import Image33x from './images/image-3@3x.png';

import Image4 from './images/image-4.png';
import Image42x from './images/image-4@2x.png';
import Image43x from './images/image-4@3x.png';

import Slider from "react-slick";


let cx = classNames.bind(styles);

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    ><RightArrow/></div>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    ><LeftArrow/></div>
    );
}

const Reviews = (props) => (
    <div className={styles.reviews}>
        <Row type="flex" justify="center" align="top">
            <Col md={22} lg={22} xl={16}>
                <Slider {...{      
                    dots: true,
                    infinite: true,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    nextArrow: <SampleNextArrow />,
                    prevArrow: <SamplePrevArrow />
                }}>
                  <div>
                    <Row>
                        <Col span={16} offset={1}>
                            <div className={styles.reviewItem}>
                                <div className={styles.quoteStart}>
                                    <QuoteStart/>
                                </div>
                                
                                <div className={styles.quote}>
                                    <span className={styles.subheader}>It’s so fun to PRINT EVERYTHING IN COLOR without
                                        feeling guilty about the cost!  Affordable ink, delivered before I even know I
                                        need it! What more can I ask for? Thanks HP!!</span>
                                </div>
                                
                                <div className={styles.quoteEnd}>
                                    <QuoteEnd/>
                                </div>
                            </div>
                        </Col>
                        <Col span={4} offset={2}>
                            <img src={Image1} className={styles.person} alt="Person Photo"
                                 srcSet={`${Image12x} 2x,
                                         ${Image13x} 3x`}/>
                                         
                            <div className={styles.name}>Kelly Hill</div>
                            <div className={styles.location}>Mom of 2 / Arcadia, IN</div>
                        </Col>
                    </Row>
                  </div>
                  <div>
                    <Row>
                        <Col span={16} offset={1}>
                            <div className={styles.reviewItem}>
                                <div className={styles.quoteStart}>
                                    <QuoteStart/>
                                </div>
                                
                                <div className={styles.quote}>
                                    <span className={styles.subheader}>I'm an infrequent user barely over 20 pages a month, most months. Instant Ink came with a printer I purchased a few years ago, three months free. I've been hooked ever since. </span>
                                </div>
                                
                                <div className={styles.quoteEnd}>
                                    <QuoteEnd/>
                                </div>
                            </div>
                        </Col>
                        <Col span={4} offset={2}>
                            <img src={Image2} className={styles.person} alt="Person Photo"
                                 srcSet={`${Image22x} 2x,
                                         ${Image23x} 3x`}/>
                            <div className={styles.name}>Roberta Ricciardi</div>
                            <div className={styles.location}>Retail Associate / Connecticut</div>
                            <div className={styles.note}>HP Instant Ink Customer</div>
                        </Col>
                    </Row>
                  </div>
                  <div>
                    <Row>
                        <Col span={16} offset={1}>
                            <div className={styles.reviewItem}>
                                <div className={styles.quoteStart}>
                                    <QuoteStart/>
                                </div>

                                <div className={styles.quote}>
                                   <span className={styles.subheader}> Instant ink has made life soooooooo much easier
                                     by making it so we never have to worry about running out of ink. We always seemed to run out just at the worst times with school printing. Now we always have ink when we need it.</span>
                                </div>
                                
                                <div className={styles.quoteEnd}>
                                    <QuoteEnd/>
                                </div>
                            </div>
                        </Col>
                        
                        <Col span={4} offset={2}>
                            <img src={Image3} className={styles.person} alt="Person Photo"
                                 srcSet={`${Image32x} 2x,
                                         ${Image33x} 3x`}/>
                            <div className={styles.name}>Josiah Corkins</div>
                            <div className={styles.location}>Learning Specialist / Davenport, FL</div>
                            <div className={styles.note}>HP Instant Ink Customer</div>
                        </Col>
                    </Row>
                  </div>
                    {/*
                  <div>
                    <Row>
                        <Col span={16} offset={1}>
                            <div className={styles.reviewItem}>
                                <div className={styles.quoteStart}>
                                    <QuoteStart/>
                                </div>

                                <div className={styles.quote}>
                                    <span className={styles.subheader}>I’m a stay at home Mom of 2 girls. Between school, Girl Scouts, Dance Class, and other activities, it is hard to find time for everything. Whatever can make life a little easier helps tremendously. HP Instant Ink is one that does just that. It is so easy and directly linked to my printer. They send the ink and I don’t have to worry about a thing. Love this service and highly recommend it!!</span>
                                </div>
                                
                                <div className={styles.quoteEnd}>
                                    <QuoteEnd/>
                                </div>
                            </div>
                        </Col>
                        <Col span={4} offset={2}>
                            <img src={Image4} className={styles.person} alt="Person Photo"
                                 srcSet={`${Image42x} 2x,
                                         ${Image43x} 3x`}/>
                            <div className={styles.name}>Rebecca Ott</div>
                            <div className={styles.location}>Mom of 2 / Lake Worth, FL</div>
                            <div className={styles.note}>HP Instant Ink Customer</div>
                        </Col>
                    </Row>
                  </div>
                  */}
                </Slider>
            </Col>
        </Row>
    </div>
);

export default Reviews;
